import { useOrgAuthStore } from "@solomon-apps/shared";
import type { ComplianceRequirementListView } from "@solomon-apps/shared";
import { useQuery } from "@tanstack/react-query";

import { fetchClientComplianceRequirements } from "@/services/clientCompliance";

interface UseClientComplianceRequirementsReturn {
    requirements: ComplianceRequirementListView | null;
    isLoading: boolean;
    error: Error | null;
    hasSelectedContext: boolean;
}

export function useClientComplianceRequirements({
    enabled = true
}: {
    enabled?: boolean;
} = {}): UseClientComplianceRequirementsReturn {
    const tokens = useOrgAuthStore((s) => s.tokens);
    const selectedClientContextUuid = useOrgAuthStore((s) => s.selectedClientContextUuid);
    const authReady = Boolean(tokens && tokens.expiresAt >= Date.now() + 30_000);
    const hasSelectedContext = Boolean(selectedClientContextUuid);

    const { data, isLoading, error } = useQuery<ComplianceRequirementListView, Error>({
        queryKey: ["yaas-client", "compliance-requirements", selectedClientContextUuid],
        queryFn: fetchClientComplianceRequirements,
        enabled: enabled && authReady && hasSelectedContext,
        staleTime: 30_000
    });

    return {
        requirements: data ?? null,
        isLoading: enabled && authReady && hasSelectedContext ? isLoading : false,
        error,
        hasSelectedContext
    };
}
